import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { Table } from '@tanstack/react-table';

// import { MAX_TABLE_ROWS } from 'constants/constants';
import Button from 'components/Button/Button';

const DataTablePagination = ({
  table,
  rowCount
}: {
  table: Table<any>;
  rowCount?: number;
}) => {
  const { pageIndex, pageSize } = table.getState().pagination;
  const totalRows = rowCount ?? table.getFilteredRowModel().rows.length;

  const startItem = totalRows > 0 ? pageIndex * pageSize + 1 : 0;
  const endItem = Math.min((pageIndex + 1) * pageSize, totalRows);

  return (
    <div className="flex items-center justify-between py-4 w-full">
      <div className="text-sm text-base-mutedForeground">
        Showing {startItem}-{endItem} of {totalRows} rows
      </div>
      <div className="flex items-center gap-2">
        <Button
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
          variant="secondary"
        >
          <FontAwesomeIcon icon="fa-solid fa-chevron-left" />
        </Button>
        <Button
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
          variant="secondary"
        >
          <FontAwesomeIcon icon="fa-solid fa-chevron-right" />
        </Button>
      </div>
    </div>
  );
};

export default DataTablePagination;
